'use strict';

var performance_filter_model = require('./performance_filter.model.js');
var app_install_change_model = require('./app_install_change.model.js');
var user_login_model = require('./user_login.model.js');
var page_view_model = require('./page_view.model.js');
var copy_landing_page_model = require('./copy_landing_page.model.js');
var blast_composed_model = require('./blast_composed.model.js');
var blast_sent_model = require('./blast_sent.model.js');
var blast_errored_model = require('./blast_errored.model.js');
var block_updated_text_signup_model = require('./block_updated_text_signup.model.js');
var block_updated_email_signup_model = require('./block_updated_email_signup.model.js');
var guide_clicked_model = require('./guide_clicked.model.js');
var action_item_clicked_model = require('./action_item_clicked.model.js');
var pico_link_click_featured_model = require('./pico_link_click_featured.model.js');
var dashboard_open_model = require('./dashboard_open.model.js');
var username_update_model = require('./username_update.model.js');
var cart_failed_model = require('./cart_failed.model.js');
var cart_started_model = require('./cart_started.model.js');
var cart_completed_model = require('./cart_completed.model.js');
var cart_dismissed_model = require('./cart_dismissed.model.js');
var call_to_action_accepted_model = require('./call_to_action_accepted.model.js');
var call_to_action_declined_model = require('./call_to_action_declined.model.js');
var call_to_action_presented_model = require('./call_to_action_presented.model.js');
var card_added_model = require('./card_added.model.js');
var card_updated_model = require('./card_updated.model.js');
var card_deleted_model = require('./card_deleted.model.js');
var card_errored_model = require('./card_errored.model.js');

var schemas = {
  page_view: page_view_model,
  user_login: user_login_model,
  app_install_change: app_install_change_model,
  performance_filter: performance_filter_model,
  copy_landing_page: copy_landing_page_model,
  blast_composed: blast_composed_model,
  blast_sent: blast_sent_model,
  'blast:errored': blast_errored_model,
  'block_updated:text_signup': block_updated_text_signup_model,
  'block_updated:email_signup': block_updated_email_signup_model,
  'guide:clicked': guide_clicked_model,
  'action_item:clicked': action_item_clicked_model,
  'pico_link:click_featured': pico_link_click_featured_model,
  dashboard_open: dashboard_open_model,
  username_update: username_update_model,
  'cart:failed': cart_failed_model,
  'cart:started': cart_started_model,
  'cart:completed': cart_completed_model,
  'cart:dismissed': cart_dismissed_model,
  'call_to_action:accepted': call_to_action_accepted_model,
  'call_to_action:declined': call_to_action_declined_model,
  'call_to_action:presented': call_to_action_presented_model,
  'card:added': card_added_model,
  'card:updated': card_updated_model,
  'card:deleted': card_deleted_model,
  'card:errored': card_errored_model
};
var dashboardSchemas = schemas;

module.exports = dashboardSchemas;
//# sourceMappingURL=index.js.map
